import React from 'react';
import { useApplicationContext } from '../context/useApplicationContext';
import { NavigationItem } from 'ui-toolkit';
import { eSingleFields } from '../context/state/eSingleFields';
import { eApplicationActions } from '../context/actions/eApplicationActions';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IModalTriggerButtonProps {
  fieldName: eSingleFields;
  disabled?: boolean;
}

export const ModalTriggerButton: FCWithChildren<IModalTriggerButtonProps> = ({ children, fieldName, disabled }) => {
  const [, dispatch] = useApplicationContext();
  return (
    <NavigationItem
      text={``}
      isInline
      onClick={() => {
        dispatch({ type: eApplicationActions.OpenEditSingleFieldAction, payload: fieldName });
      }}
      disabled={disabled}
    >
      {children}
    </NavigationItem>
  );
};
